import React from 'react';
import UserLayout from '../../components/Layout/UserLayout';
import ExperienceWizard from './ExperienceWizard';

export default function action({ store, params }) {
  if (!store.getState().runtime.isAuthenticated) return { redirect: `/login?refer=${encodeURIComponent('/become-a-host/experience')}` };
  return {
    title: 'Registrar experiencia',
    component: <UserLayout hideMenu><ExperienceWizard draftId={params && params.draftId} /></UserLayout>,
  };
}
